module.exports = __webpack_public_path__ + "img/search.5a44b6a4.svg";